import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// import { put, takeLatest } from "redux-saga/effects";
// import { getUserByToken } from "../../crud/auth.crud";
// import * as routerHelpers from "../../router/RouterHelpers";

export const actionTypes = {
  Login: "[Login] Action",
  // Logout: "[Logout] Action",
  // Register: "[Register] Action",
  // UserRequested: "[Request User] Action",
  // UserLoaded: "[Load User] Auth API",
  // CompanyLoaded: "[Company User] Auth API",
  // RoleLoaded: "[Role User] Auth API",
  // PermissionsLoaded: "[Permissions User] Auth API"
};

const initialAuthState = {
  user: undefined,
  company: undefined,
  role: undefined,
  permissions: undefined,
  authToken: undefined,
};

export const reducer = persistReducer(
  {
    storage,
    key: "auth",
    whitelist: ["user", "authToken", "company", "role", "permissions"],
  },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        const { authToken } = action.payload;

        return { authToken, user: undefined };
      }

      default:
        return state;
    }
  }
);

export const actions = {
  login: (authToken) => ({ type: actionTypes.Login, payload: { authToken } }),
};

export function* saga() {}
